<template>
  <div class="input-box">
    <label class="label-text">{{ label }} *</label>
    <div class="form-group">
      <span class="la la-phone form-icon"></span>
      <input class="form-control" :id="uuId" type="tel" autocomplete="off" placeholder="Telefon Numarası" v-model="displayModel">
      <span :id="uuId+'error-msg'" class="hide error-text"></span>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { alpha, required } from 'vee-validate/dist/rules';
import validationMethodsMixin from "../../mixin/validationMethodsMixin";
import intlTelInput from "intl-tel-input";
import utils from 'intl-tel-input/build/js/utils';


export default {
  name: "BasePhoneInput",
  mixins : [validationMethodsMixin],
  components : {ValidationProvider},
  data :() => {
    return {
      valid : null,
      displayModel : null
    };
  },
  props : {
    label : null,
    type : String,
    rules : String,
    uuId : String,
    inputModel : null
  },
  model: {
    prop: 'inputModel',
    event: 'change'
  },
  mounted() {

    setTimeout(()=>{
      const input = document.querySelector("#"+this.uuId);
      const errorMsg = document.querySelector("#"+this.uuId+"error-msg");
      const phoneInput = intlTelInput(input, {
        initialCountry: "auto",
        utilsScript: utils,
        geoIpLookup: function(success, failure) {
          $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
            var countryCode = (resp && resp.country) ? resp.country : "tr";
            success(countryCode);
          });
          failure("tr")
        },
      });

      let reset = function() {
        const input = document.querySelector("#"+this.uuId);
        const errorMsg = document.querySelector("#"+this.uuId+"error-msg");
        input.classList.remove("error");
        errorMsg.innerHTML = "";
        errorMsg.classList.add("hide");
      };
      input.addEventListener('blur', function() {
        reset();
        if (input.value.trim()) {
          if (!phoneInput.isValidNumber()) {
            input.classList.add("error");
            let errorCode = phoneInput.getValidationError();

            if(errorCode === -99){
              errorMsg.innerHTML= "Geçersiz numara";
            }else {
              errorMsg.innerHTML = ["Geçersiz Numara", "Invalid country code", "Çok kısa", "Çok uzun", "Geçersiz Numara"][errorCode];
            }
            errorMsg.classList.remove("hide");
          }
        }
      });
    },2000)

    this.displayModel = this.inputModel;
  }
}
</script>

<style scoped>

</style>